import { render, staticRenderFns } from "./DemoMonthPickerAllowedMonths.vue?vue&type=template&id=207f4114&"
import script from "./DemoMonthPickerAllowedMonths.vue?vue&type=script&lang=js&"
export * from "./DemoMonthPickerAllowedMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
